import { IconSecurityHide, IconSecurityShow } from '@doppio/icons';
import { ActivityIndicator, View } from 'dripsy';
import * as React from 'react';
import { BtnIcon } from './BtnIcon';
import { StyledInput } from './StyledInput';
export const Input = React.forwardRef(({ value, defaultValue, isDisabled, isLoading, isSuccess, secureTextEntry, iconLeft, iconRight, onIconRightPress, sx, ...props }, forwardedRef) => {
    const [isPassword, setIsPassword] = React.useState(secureTextEntry);
    let buttonProps = {};
    if (secureTextEntry) {
        buttonProps = {
            accessible: true,
            accessibilityRole: 'button',
            accessibilityLabel: isPassword ? 'Show password' : 'Hide password',
            onPress: () => setIsPassword(!isPassword),
            children: isPassword ? (React.createElement(IconSecurityShow, { accessible: false })) : (React.createElement(IconSecurityHide, { accessible: false })),
        };
    }
    if (isLoading) {
        buttonProps = {
            accessible: false,
            accessibilityRole: 'image',
            accessibilityLabel: 'Loading',
            pointerEvents: 'none',
            children: React.createElement(ActivityIndicator, { color: "text", sx: { height: 24, width: 24 } }),
        };
    }
    if (iconRight) {
        const accessible = Boolean(onIconRightPress);
        buttonProps = {
            accessible,
            accessibilityRole: accessible ? 'button' : 'image',
            ...(!accessible && { pointerEvents: 'none' }),
            onPress: onIconRightPress,
            children: iconRight,
        };
    }
    const shouldRenderBtnIcon = iconRight || isLoading || secureTextEntry;
    const shouldRenderLeftIcon = Boolean(iconLeft);
    return (React.createElement(View, { sx: { position: 'relative' } },
        shouldRenderLeftIcon && (React.createElement(View, { sx: {
                position: 'absolute',
                left: '$0',
                top: '$0',
                bottom: '$0',
                width: '$8',
                alignItems: 'center',
                justifyContent: 'center',
            }, pointerEvents: "none", accessible: false }, iconLeft)),
        React.createElement(StyledInput, { ref: forwardedRef, value: value, defaultValue: defaultValue, isSuccess: isSuccess, secureTextEntry: isPassword, isDisabled: isDisabled, ...props, sx: {
                ...sx,
                ...(shouldRenderLeftIcon && { paddingLeft: '$8' }),
            } }),
        shouldRenderBtnIcon && (React.createElement(BtnIcon, { isDisabled: isDisabled, ...buttonProps }, buttonProps.children))));
});
Input.displayName = 'Input';
//# sourceMappingURL=Input.js.map